import { Box } from "@mui/material";
import { EntityType } from "@common/Common.types.ts";
import { DotLegalFullScreenSpinner } from "@dotlegal/dotlegal-ui-components";
import OverviewStepSection from "@common/components/overviewStepSection/OverviewStepSection";
import { useLegalEntityStepTab } from "./LegalEntityStepTab.hooks";
import { topPaperMinHeight } from "../LegalEntity";
import useLegalEntityDisplayFields, { getLegalEntityFieldDisplayName } from "../legalEntities/legalEntityDisplayFields/LegalEntityDisplayFields.hooks";
import { LegalEntityScope } from "../legalEntities/LegalEntities.types";
import { useUrlProvider } from "../../useUrlProvider";

export interface LegalEntityStepTabProps {
    legalEntityId: string;
    stepId: string;
    legalEntityScope: LegalEntityScope;
}

function LegalEntityStepTab(props: LegalEntityStepTabProps) {
    const { isLoading, data } = useLegalEntityStepTab(props);
    const { getTableFieldsDictionary, isLoading: isFieldsLoading } = useLegalEntityDisplayFields(props.legalEntityScope);
    const { getLegalEntityEditUrl } = useUrlProvider();

    if (isFieldsLoading || isLoading) {
        return (
            <Box sx={{ height: topPaperMinHeight }}>
                <DotLegalFullScreenSpinner />
            </Box>
        );
    }

    return (
        <Box sx={{ minHeight: topPaperMinHeight, px: 0.5 }}>
            <OverviewStepSection
                step={data!}
                entityId={props.legalEntityId}
                entityType={EntityType.LegalEntity}
                hideHeader
                getFieldDisplayName={getLegalEntityFieldDisplayName}
                dictionary={getTableFieldsDictionary()}
                navigateUrl={data?.canNavigate ? getLegalEntityEditUrl(props.legalEntityScope, props.legalEntityId, `step=${data.stepOrder}`) : undefined}
                canNavigate={data?.canNavigate}
            />
        </Box>
    );
}

export default LegalEntityStepTab;
